var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-117a2ba0!../../node_modules/vue-loader/lib/selector?type=template&index=0!./mobile.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./docs/components/mobile.vue
// module id = 49
// module chunks = 3